import Controller from '@ember/controller';

export default class AnalysisController extends Controller {}
